import React, { Component } from "react";
import { useSelector } from "react-redux";
import { RasioKeuangan } from "./Dashboard/RasioKeuangan";
import { RasioKeuanganCompany } from "./Dashboard/RasioKeuanganCompany";
import { TrenKinerja } from "./Dashboard/TrenKinerja";
import DocumentReport from "./Dashboard/DocumentReport";
import { isBiro } from "../utils/helper";
import Kontribusi from "./Dashboard/Kontribusi";
import { Loader } from "semantic-ui-react";
import LoadingTop from "../component/LoadingTop";

export default (props) => {
  const companies = useSelector(
    (state) => state.perusahaanReducer.listPerusahaan
  );
  const compNumbers = companies.content.length;

  const getPie = () => {
    if (isBiro()) {
      if (compNumbers > 1) {
        return (
          <>
            <div className="row mb-3">
              <Kontribusi />
              {/* <DocumentReport /> */}
            </div>
            <hr />
          </>
        );
      }
      return (
        <center style={{ margin: "60px", color: "gray", fontStyle: "italic" }}>
          <h5>Tidak cukup data untuk menampilkan grafik.</h5>
        </center>
      );
    }
    return <>
      <div className="row mb-3">
        <Kontribusi />
        {isBiro() &&
          <DocumentReport />
        }
      </div>
      <hr />
    </>
  };

  const getTren = () => {
    if (!isBiro()) return <>
      <div className="row mt-3">
        <TrenKinerja />
      </div>
    </>
    else if (compNumbers <= 1) return <div />;
    else return <>
      <div className="row mt-3">
        <TrenKinerja />
      </div>
    </>
  };

  const getRatio = () => {
    if (isBiro()) return <>
      <div className="row mb-3">
        <RasioKeuangan />
      </div>
      <hr />
    </>
    // else if (compNumbers <= 1) return <RasioKeuanganCompany />
    else return <>
      <div className="row mb-3">
        <RasioKeuanganCompany />
      </div>
      <hr />
    </>
  };
  if (companies.content.length === 0 && isBiro()) {
    return (
      <div className="w-100 d-flex justify-content-center">
        <Loader active>Loading</Loader>
      </div>
    );
  }
  return (
    <div className="container-fluid mt-3">
      <div className="container">

        <LoadingTop />
        {getPie()}
        {getRatio()}
        {getTren()}
      </div>
    </div>

  );
};
